import React from 'react';
import { Badge } from '../../components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';

const PackagesGrid = ({
  handleSelectPackage,
  packages,
  selectedPackage,
  eurPrices,
}) => {
  const euro = eurPrices?.euro ? eurPrices : null;
  const eurDe = (id) => euro?.packages?.find((p) => p.id === id);
  // conta da região do euro só vê pacote que ela pode pagar
  const lista = euro
    ? packages.filter((p) => eurDe(p.id)?.eligible)
    : packages;
  const num2 = (v) => Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const pct = (v) => Number(v || 0).toLocaleString('pt-BR', { maximumFractionDigits: 2 });

  return (
    <TabsContent value="packages" className="mt-4">
                        {/* Card de Pacotes com fundo de moedas */}
                        <Card 
                          data-testid="packages-card"
                          className="relative overflow-hidden"
                          style={{
                            backgroundImage: `url('https://customer-assets.emergentagent.com/job_8f198eda-3cd9-45f6-a741-5b80db2d25c7/artifacts/hu3a1r4s_ChatGPT%20Image%2015%20de%20fev.%20de%202026%2C%2012_41_24.png')`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                          }}
                        >
                    <CardHeader className="relative z-10">
                      <CardTitle 
                        className="text-orange-400 font-black"
                        style={{
                          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 2px 2px 4px rgba(0,0,0,0.5)'
                        }}
                      >
                        2. Escolha seu pacote
                      </CardTitle>
                      <CardDescription 
                        className="text-white font-medium"
                        style={{
                          textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000, 2px 2px 3px rgba(0,0,0,0.5)'
                        }}
                      >
                        Selecione a quantidade de moedas desejada
                      </CardDescription>
                      {euro && (
                        <p
                          className="relative z-10 mt-1 text-[11px] font-medium text-emerald-200"
                          data-testid="eur-rate-note"
                          style={{ textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000' }}
                        >
                          Cotação 1 € = R$ {num2(euro.rate)}
                          {euro.method === 'mbway' && ` · taxa ${pct(euro.fee_pct)}% + € ${num2(euro.fee_fixed_eur)}`}
                        </p>
                      )}
                    </CardHeader>
                    <CardContent className="relative z-10">
                      <div className="space-y-3">
                        {lista.length === 0 ? (
                          <p className="text-center text-white py-4">Nenhum pacote disponível no momento</p>
                        ) : (
                          lista.map((pkg) => {
                            const isAvailable = pkg.available !== false;
                            const isDisabled = !isAvailable;
                            const isSelected = selectedPackage?.id === pkg.id;
                            
                            return (
                              <div 
                                key={pkg.id} 
                                data-testid={`package-${pkg.id}`}
                                onClick={() => !isDisabled && handleSelectPackage(pkg)}
                                className={`relative overflow-hidden rounded-xl transition-all duration-200 ${
                                  isDisabled 
                                    ? 'cursor-not-allowed'
                                    : 'cursor-pointer hover:scale-[1.01] active:scale-[0.99]'
                                }`}
                              >
                                <div className={`p-3 sm:p-4 rounded-xl ${
                                  isDisabled 
                                    ? 'bg-gray-200 border-2 border-gray-300'
                                    : isSelected
                                      ? 'bg-gradient-to-r from-purple-600 via-purple-500 to-indigo-500 border-2 border-purple-300 shadow-xl shadow-purple-500/40'
                                      : 'bg-white border-2 border-gray-100 hover:border-purple-400 hover:shadow-lg'
                                }`}>
                                  
                                  {/* MARCA D'ÁGUA - INDISPONÍVEL */}
                                  {isDisabled && (
                                    <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
                                      <span className="text-xl sm:text-2xl font-black text-red-500/50 uppercase tracking-wider">
                                        INDISPONÍVEL
                                      </span>
                                    </div>
                                  )}
                                  
                                  {/* Badge de seleção */}
                                  {isSelected && (
                                    <div className="absolute top-2 right-2 sm:top-3 sm:right-3">
                                      <div className="w-6 h-6 sm:w-7 sm:h-7 bg-white rounded-full flex items-center justify-center shadow-lg">
                                        <svg className="w-4 h-4 sm:w-5 sm:h-5 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                                        </svg>
                                      </div>
                                    </div>
                                  )}
                                  
                                  <div className={`flex items-center justify-between gap-2 sm:gap-3 ${isDisabled ? 'opacity-40' : ''}`}>
                                    {/* Lado esquerdo - Ícone + Moedas */}
                                    <div className="flex items-center gap-2 sm:gap-3">
                                      <img 
                                        src="https://customer-assets.emergentagent.com/job_8f198eda-3cd9-45f6-a741-5b80db2d25c7/artifacts/uhy6yxmh_ChatGPT%20Image%2015%20de%20fev.%20de%202026%2C%2013_18_27.png" 
                                        alt="Moeda"
                                        className="w-10 h-10 sm:w-12 sm:h-12 object-contain"
                                      />
                                      <div>
                                        {/* Nome do pacote */}
                                        {pkg.name && (
                                          <p className={`text-xs sm:text-sm font-bold ${isSelected ? 'text-purple-200' : 'text-gray-700'}`}>
                                            {pkg.name}
                                          </p>
                                        )}
                                        <p className={`text-xl sm:text-2xl font-black ${isSelected ? 'text-white' : 'text-orange-500'}`}>
                                          {pkg.coins.toLocaleString('pt-BR')}
                                        </p>
                                        <p className={`text-[10px] sm:text-xs font-semibold uppercase tracking-wider ${isSelected ? 'text-purple-200' : 'text-gray-400'}`}>
                                          moedas
                                        </p>
                                      </div>
                                    </div>
                                    
                                    {/* Lado direito - Preços */}
                                    <div className="text-right flex-shrink-0">
                                      <p
                                        className={`text-lg sm:text-2xl font-black ${isSelected ? 'text-white' : 'text-purple-600'}`}
                                        data-testid={euro ? `package-price-eur-${pkg.id}` : undefined}
                                      >
                                        {euro
                                          ? `€ ${num2(eurDe(pkg.id)?.amount_eur)}`
                                          : `R$ ${pkg.price.toFixed(2)}`}
                                      </p>
                                      {euro && eurDe(pkg.id)?.fee_eur > 0 && (
                                        <p className={`text-[10px] ${isSelected ? 'text-purple-200' : 'text-gray-400'}`}>
                                          inclui € {num2(eurDe(pkg.id).fee_eur)} de taxa
                                        </p>
                                      )}
                                    </div>
                                  </div>
                                  
                                  {/* Descrição do pacote */}
                                  {pkg.description && (
                                    <p className={`text-xs mt-2 pl-12 sm:pl-15 ${isSelected ? 'text-purple-200' : 'text-gray-500'}`}>
                                      {pkg.description}
                                    </p>
                                  )}
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </CardContent>
                  </Card>
                      </TabsContent>
  );
};

export default PackagesGrid;
